import { UUID } from 'v2/core/entities/uuid';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';

function fixNormalisedNodeField(
  node: NormalisedNode,
  nodes: Record<UUID, NormalisedNode>,
) {
  if (node.type === 'filter') {
    if (node.field === 'reviewSentiment') {
      node.field = 'sentiment';
      return;
    }
  }

  if (node.type === 'group') {
    node.children.forEach((child) => {
      fixNormalisedNodeField(nodes[child], nodes);
    });
  }
}

export function fixNormalisedNodeFields(nodes: Record<UUID, NormalisedNode>) {
  Object.values(nodes).forEach((node) => {
    fixNormalisedNodeField(node, nodes);
  });
}
